/** Attendance (docs/14 B14): one state per student and day, kept apart from recitation results. */
import { z } from "zod";
const date = z.iso.date();
export const AttendanceStatus = z.object({
    id: z.uuid(),
    code: z.string(),
    name: z.string(),
    countsAsPresent: z.boolean(),
});
export const AttendanceEntry = z.object({
    enrollmentId: z.uuid(),
    student: z.object({ id: z.uuid(), name: z.string() }),
    /** null: «لم يُسجل بعد». */
    record: z
        .object({
        statusId: z.uuid(),
        /** auto: no recitation by the study day's cutoff (B14, 2026-10-18). */
        source: z.enum(["teacher", "session", "auto"]),
        note: z.string().nullable(),
        updatedAt: z.string(),
    })
        .nullable(),
});
export const CircleAttendanceResponse = z.object({
    date: z.string(),
    statuses: z.array(AttendanceStatus),
    students: z.array(AttendanceEntry),
});
export const AttendanceQuery = z.object({ date });
export const RecordAttendanceBody = z.object({
    date,
    entries: z
        .array(z.object({
        enrollmentId: z.uuid(),
        statusId: z.uuid(),
        note: z.string().trim().max(500).optional(),
    }))
        .min(1)
        .max(200),
});
export const MyAttendanceQuery = z.object({ from: date, to: date });
export const MyAttendanceResponse = z.object({
    statuses: z.array(AttendanceStatus),
    days: z.array(z.object({ date: z.string(), circle: z.string(), statusId: z.uuid() })),
});
/** The portal's daily attendance overview: one row per circle in the caller's scope. */
export const AttendanceSummaryResponse = z.object({
    date: z.string(),
    circles: z.array(z.object({
        circle: z.object({ id: z.uuid(), name: z.string() }),
        branchName: z.string(),
        students: z.number(),
        present: z.number(),
        absent: z.number(),
        unrecorded: z.number(),
    })),
});
//# sourceMappingURL=attendance.js.map